<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h4>자동등록 안내</h4>
			</div>
			<div class="tab-menu mb30 depth1">
				<a @click="onTab(1)" :class="active==1?'active':''">타오바오 / 1688</a>  <!-- href="#tab1" -->
				<!-- <a @click="onTab(2)" :class="active==2?'active':''">air.1688</a>   -->
			</div>
			
			<div class="tab-content mb50" v-if="active == 1">
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<p>&lt; 타오바오 &gt;</p>
						<div class="img-box" style="margin-bottom: 100px;">
							<img loading="lazy" src="../../assets/list/auto-taobao.png" alt="" class="img-responsive center-block">
						</div>
						<p>&lt; 1688 &gt;</p>
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">01</span>
						<p>타오바오 / 1688 에 로그인 후 구매내역으로 이동합니다.</p>
					</div>
				</div>
				
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao2.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">02</span>
						<p>CTRL + A 를 눌러 전체선택한 후 CTRL + C 를 눌러 복사해 주세요 <br>
							또는 마우스를 드래그하여 선택하세요</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao3.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">03</span>
						<p>고로켓고 배송대행 신청서 작성하기 페이지에 접속한 후 [구매목록 가져오기] 버튼을 클릭합니다.</p>
					</div>
				</div>
				
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao4.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">04</span>
						<p>가져올 사이트를 선택하고 CTRL + V 를 눌러 붙여넣어 줍니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao5.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">05</span>
						<p>[가져오기] 버튼을 클릭합니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao6.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">06</span>
						<p>
							상품 목록이 정상적으로 입력된 것을 확인할 수 있습니다.<br>
							품목분류는 직접 지정해주셔야 하므로 품목분류 [선택하기] 버튼을 클릭합니다.
						</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao7.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">07</span>
						<p>적절한 품목분류를 선택해 줍니다.</p>
					</div>
				</div>
				<!-- <div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-taobao8.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">08</span>
						<p>맨 하단의 [품목분류 일괄적용] 버튼을 통해 일괄 지정도 가능합니다.</p>
					</div>
				</div> -->

			</div>
			<div class="tab-content mb50" v-else>
				<div class="air-guide">
					1688의 마이페이지 주소는 trade.1688 로 시작합니다.<br>
					그러나 최근 1688의 업데이트로 인해 일부 아이디의 경우 air.1688 로 이동하여 전체 복사가 제대로 되지 않는 문제점이 발생했습니다.<br>
					주소 확인 시  air 로 시작하는 마이페이지일 경우 아래의 방법으로 진행해 주시기 바랍니다.
					<img loading="lazy" src="../../assets/list/auto-1688-url.png" alt="" class="img-responsive center-block">
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">01</span>
						<p>1688 에 로그인 후 구매내역으로 이동합니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air2.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">02</span>
						<p>CTRL + A 를 누르면 이와 같이 상품 영역이 복사되지 않는 문제점이 있습니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air3.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">03</span>
						<p>모든 상품을 불러올 수 있도록 [展开更多] 버튼을 클릭하여 상품을 펼쳐주세요</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air4.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">04</span>
						<p>상품이 전부 펼쳐진 것을 확인한 후 </p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air5.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">05</span>
						<p>상품명 부분을 클릭합니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air6.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">06</span>
						<p>CTRL + A 를 눌러 상품영역이 모두 선택된 것을 확인합니다.<br><span class="color-red">(반드시 상품 영역이 제대로 선택이 되었는지 확인한 후)</span> CTRL + C 를 눌러 복사합니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air7.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">07</span>
						<p>고로켓고 배송대행 신청서 작성하기 페이지에 접속한 후 [구매목록 가져오기] 버튼을 클릭합니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air8.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">08</span>
						<p>알리바바를 선택하고 CTRL + V 를 눌러 붙여넣어 줍니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air9.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">09</span>
						<p>[가져오기] 버튼을 클릭합니다.</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air10.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">10</span>
						<p>
							상품 목록이 정상적으로 입력된 것을 확인할 수 있습니다.<br>
							품목분류는 직접 지정해주셔야 하므로 품목분류 [선택하기] 버튼을 클릭합니다.
						</p>
					</div>
				</div>
				<div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air11.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">11</span>
						<p>적절한 품목분류를 선택해 줍니다.</p>
					</div>
				</div>
				<!-- <div class="type-card shadow-all mb50 mb20-xs">
					<div class="card-body text-center">
						<div class="img-box">
							<img loading="lazy" src="../../assets/list/auto-1688-air12.png" alt="" class="img-responsive center-block">
						</div>
						<span class="num">12</span>
						<p>맨 하단의 [품목분류 일괄적용] 버튼을 통해 일괄 지정도 가능합니다.</p>
					</div>
				</div> -->
						
				
			</div>
			
			
		</div>
		
	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	export default {
		components: {
			PersonalBanner
		},
		data() {
			return {
				active:1,
			
			};
		},
		created() {
			
		},
		methods: {
			onTab(index){
				this.active = index
			}
		}
		
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: #111;
		margin-bottom: 60px;
	}
	.title-wrap h4 {
	    font-weight: 700;
	    font-size: 36px;
	    line-height: 1.34;
	    margin: 0;
	}
	.tab-menu {
	    display: flex;
	    gap: 0 10px;
	}
	.tab-menu > a.active {
	    color: #fff;
	    background: var(--main-color);
	}
	.tab-menu > a {
	    flex: 1;
	    background: #FFFFFF;
	    border: 1px solid #E8E8E8;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	    border-radius: 10px;
	    font-weight: 700;
	    font-size: 20px;
	    color: #303030;
	    line-height: 56px;
	    transition: 0.25s;
	    text-align: center;
	    text-decoration: none;
		cursor: pointer;
	}
	.tab-content{
		
	}
	/* 内容列表 */
	.type-card {
	    border: 1px solid var(--border-color);
	    border-radius: 26px;
	    overflow: hidden;
	}
	.type-card.shadow-all {
	    border: none;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	}
	.type-card > .card-body {
	    padding-top: 48px;
	    padding-bottom: 39px;
	}
	.type-card > .card-body {
	    padding: 26px;
	    background: #fff;
	}
	.type-card > .card-body > p {
	    font-size: 15px;
	    color: #111111;
	    line-height: 1.8;
		font-weight: bold;
	}
	.type-card .img-box {
	    display: flex;
	    justify-content: space-between;
	}
	.img-box {
	    margin-bottom: 25px;
	}
	.img-responsive {
	    display: block;
	    max-width: 100%;
	    height: auto;
	}
	span.num {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    width: 30px;
	    height: 30px;
	    font-size: 14px;
	    font-weight: bold;
	    color: #FF4000;
	    background-color: #FBF3EA;
	    border-radius: 50%;
	    margin: 0 auto 10px;
	}
	.air-guide {
	    background: #f4f6f9;
	    padding: 20px;
	    text-align: center;
	    border-radius: 26px;
	    margin-bottom: 50px;
	}
	.air-guide img {
	    margin-top: 20px;
	}
	.center-block {
	    display: block;
	    margin-right: auto;
	    margin-left: auto;
	}
	
	
	.text-center {
	    text-align: center !important;
	}
	.mb30 {
	    margin-bottom: 30px !important;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {	
		.content-zsy{
			margin: 0 10px;
		}
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h4 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
		}
		
	}
</style>